import { render, staticRenderFns } from "./PeoplePicker.vue?vue&type=template&id=26ad4013"
import script from "./PeoplePicker.vue?vue&type=script&lang=ts"
export * from "./PeoplePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports